import {Job, JobState, RootState} from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';

type JobGetter = GetterTree<JobState, RootState>;

export const initialState = (): JobState => {
  return {
    initialState,
    activeJobs: [],
    completedJobs: [],
  };
};

export const getters: JobGetter = {
  activeJobs: (state) => state.activeJobs,
  completedJobs: (state) => state.completedJobs,
};

export const mutations: MutationTree<JobState> = {
  addActiveJob(state, newJob) {
    if (!state.activeJobs.map((j: any) => j.jobId).includes(newJob.jobId)) {
      state.activeJobs.unshift(newJob);
    }
  },
  addCompletedJob(state, completedJob) {
    const index = state.activeJobs.findIndex((job: Job) => job.id === completedJob.id);
    state.activeJobs.splice(index, 1);
    state.completedJobs.unshift(completedJob);
  },
  cancelJob(state, job) {
    const index = state.activeJobs.findIndex((j: Job) => j.id === job.id);
    state.activeJobs.splice(index, 1);
  },
  removeCompletedJobs(state, job) {
    const index = state.activeJobs.findIndex((j: Job) => j.id === job.id);
    state.completedJobs.splice(index, 1);
  },
  clearJobs(state) {
    state.activeJobs = [];
    state.completedJobs = [];
  },
};
export const actions: ActionTree<JobState, RootState> = {

};

export const jobs: Module<JobState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
